import { render, staticRenderFns } from "./purchaseOrderDetail.vue?vue&type=template&id=12f663bf&"
import script from "./purchaseOrderDetail.vue?vue&type=script&lang=js&"
export * from "./purchaseOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./purchaseOrderDetail.vue?vue&type=style&index=0&id=12f663bf&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports